



































































































import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, namespace, State } from "vuex-class";

import { Evidence, Match, Token } from "@/types";
import BaseToken from "@/components/BaseToken.vue";
import BaseTab from "@/components/BaseTab.vue";
import EvidencedDocument from "@/components/EvidencedDocument.vue";
import MatchedDocument from "@/components/MatchedDocument.vue";
import NavigablePane from "@/components/NavigablePane.vue";
import { isOutOfView, range } from "@/utils";
import DocumentSummary from "@/components/DocumentSummary.vue";

const Details = namespace("details");

const Evidences = namespace("evidences");

@Component({
  components: {
    DocumentSummary,
    NavigablePane,
    MatchedDocument,
    EvidencedDocument,
    BaseToken,
    BaseTab
  }
})
export default class DocumentEvidences extends Vue {
  private rightTab: string = "0";

  private type: string = "1";

  private types: [string, string, any?][] = [
    ["1", "Conditions & Symptoms"],
    ["7", "Procedures"],
    ["4", "Labs & Vitals"],
    ["6", "Medications"],
    ["15", "Misc", { width: "max-content", flexShrink: "0" }]
  ];

  private showAnalysis: boolean = true;

  private clusteredEvidences: any[][] = [];

  private clusteredRemainingMatches: any[][] = [];

  private containers: {
    left: HTMLElement | null;
    right: HTMLElement | null;
  } = {
    left: null,
    right: null
  };

  private scrollLock?: "Left" | "Right";

  private scrollTimeout?: number;

  @State("text")
  private document!: string;

  @State("tokens")
  private tokens!: Token[];

  @State("blocks")
  private blocks!: number[][];

  @Details.State("evidence")
  private evidence!: Evidence | null;

  @Evidences.Getter("parsed")
  private evidences!: Evidence[][];

  @Action("details/update")
  show!: (value: Evidence) => void;

  @Getter("matches/parsed")
  private indexed!: (type: string) => (Match[] | null)[];

  @Getter("matches/flatten")
  private flatten!: Match[];

  select(matches: Match[]) {
    this.$emit("select", matches[0]);
  }

  get matches(): (Match[] | null)[] {
    return this.indexed("1");
  }

  get remainingMatches() {
    return this.matches.map((cluster: Match[] | null, index: number) => {
      if (
        !cluster ||
        cluster.length === 0 ||
        cluster[0].context["assertion"] !== "posited" ||
        cluster[0].context["subject"] !== "patient" ||
        cluster[0].context["allergy"] === "true" ||
        this.evidences[index].length > 0 ||
        range(...cluster[0].concept.text.tokpos).filter(
          (j: number) => this.evidences[j].length > 0
        ).length > 0
      )
        return null;

      return cluster;
    });
  }

  @Watch("evidence")
  scrollTo() {
    if (this.evidences) {
      this.rightTab = "0";

      this.$nextTick(() => {
        if (this.evidence) {
          const evidences = [
            ...this.$el.querySelectorAll(
              `span[data-codes*="${this.evidence.id},"]`
            )
          ] as HTMLElement[];

          const container = this.$refs["container-right"] as HTMLElement;

          if (
            evidences &&
            evidences.length > 0 &&
            evidences.every(evidence => isOutOfView(container, evidence))
          ) {
            container.scrollTop = evidences[0].offsetTop - 100;
          }
        }
      });
    }
  }

  sync(e: Event) {
    if (!this.containers.left || !document.contains(this.containers.left)) {
      this.containers.left = this.$refs["container-left"] as HTMLElement;
    }

    if (!this.containers.right || !document.contains(this.containers.left)) {
      this.containers.right = this.$refs["container-right"] as HTMLElement;
    }

    if (
      this.containers.left &&
      e.target &&
      this.containers.left !== e.target &&
      this.scrollLock !== "Right"
    ) {
      this.containers.left.scrollTop = (e.target as HTMLElement).scrollTop;
      this.scrollLock = "Left";
    }

    if (
      this.containers.right &&
      e.target &&
      this.containers.right !== e.target &&
      this.scrollLock !== "Left"
    ) {
      this.containers.right.scrollTop = (e.target as HTMLElement).scrollTop;
      this.scrollLock = "Right";
    }

    if (this.scrollTimeout) window.clearTimeout(this.scrollTimeout);
    this.scrollTimeout = window.setTimeout(() => {
      this.scrollLock = undefined;
    }, 100);
  }
}
